import type { FC, ReactElement } from 'react';

import { CurrencyConnected } from '@pp/core/src/components/currency/CurrencyConnected';
import { Loader } from '@pp/core/src/components/loader/Loader';
import { HelpText } from '@pp/core/src/services/helpTranslations/reactBindings/HelpText';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { HIGHFLYER_PT } from '../../../config';

import styles from './HelpCrash.module.css';

export const HelpChapterCrashCashingOutConnected: FC = () => {
  const tableName = useConfigSlice.tableName(); // FIXME should use help context / prop drilling instead of redux
  const tableVariant = useConfigSlice.getTableVariant();

  if (!tableName) return <Loader />;

  return (
    <div>
      <p>
        <HelpText tk="cashingOutWithoutCashout50.cashout" />
      </p>
      <div className={styles.button_container}>
        <DisplayBetButton label="CASH_OUT_CAPS" />
        <DisplayBetButton label="CASHED_CAPS" />
      </div>
      <p>
        <HelpText
          tk="cashingOutWithoutCashout50.highFlyerCashout"
          dynamicValues={{ TABLE_NAME: <L10nText tk={tableName} /> }}
        />
      </p>
      <p>
        <HelpText tk="cashingOutWithoutCashout50.payoutRequest" />
      </p>
      {tableVariant === HIGHFLYER_PT ? null : (
        <p>
          <HelpText tk="cashingOutWithoutCashout50.roundedWinnings" />
        </p>
      )}
    </div>
  );
};

export const DisplayBetButton = ({ label }: { label: string }): ReactElement => {
  const mods = useModifiers(styles, 'bet_button', {
    cashed: label === 'CASHED_CAPS',
  });

  return (
    <div className={`${styles.bet_button} ${mods}`}>
      <div className={styles.bet_button_label}>
        <L10nText tk={label} />
      </div>
      <div className={styles.bet_button_amount}>
        <CurrencyConnected value={100} />
      </div>
    </div>
  );
};
